module.exports = __webpack_public_path__ + "static/media/parawajah-indonesia.2752b5dc.jpeg";